import { render, staticRenderFns } from "./TheHelpModal.vue?vue&type=template&id=32b1f566"
import script from "./TheHelpModal.vue?vue&type=script&lang=js"
export * from "./TheHelpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports